import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const {
    isAuthenticated,
    logout
  } = useAuth();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleLogout = () => {
    logout();
    setIsMobileMenuOpen(false);
  };
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-xl shadow-sm' : 'bg-transparent'}`} data-id="element-89">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8" data-id="element-90">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-91">
          <a href="/" className="text-xl md:text-2xl font-bold text-black" data-id="element-92">
            WellAd<span className="text-indigo-600" data-id="element-93">.</span>
          </a>
          <nav className="hidden md:flex items-center space-x-8" data-id="element-94">
            <a href="#" className="text-gray-700 hover:text-black transition-colors font-medium" data-id="element-95">
              Home
            </a>
            <a href="#features" className="text-gray-700 hover:text-black transition-colors font-medium" data-id="element-96">
              Features
            </a>
            <a href="#how-it-works" className="text-gray-700 hover:text-black transition-colors font-medium" data-id="element-97">
              How It Works
            </a>
            <a href="#pricing" className="text-gray-700 hover:text-black transition-colors font-medium" data-id="element-98">
              Pricing
            </a>
            <a href="#testimonials" className="text-gray-700 hover:text-black transition-colors font-medium" data-id="element-99">
              Testimonials
            </a>
          </nav>
          <div className="hidden md:flex items-center space-x-4" data-id="element-100">
            {isAuthenticated ? <>
                <button onClick={() => navigate('/dashboard')} className="px-6 py-2.5 text-gray-700 font-medium hover:text-black transition-colors" data-id="element-101">
                  Dashboard
                </button>
                <button onClick={handleLogout} className="px-6 py-2.5 bg-black text-white rounded-full font-medium hover:bg-gray-900 transition-all hover:shadow-lg" data-id="element-102">
                  Logout
                </button>
              </> : <>
                <button onClick={() => navigate('/login')} className="px-6 py-2.5 text-gray-700 font-medium hover:text-black transition-colors" data-id="element-103">
                  Login
                </button>
                <button onClick={() => navigate('/signup')} className="px-6 py-2.5 bg-black text-white rounded-full font-medium hover:bg-gray-900 transition-all hover:shadow-lg" data-id="element-104">
                  Get Started
                </button>
              </>}
          </div>
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2" data-id="element-105">
            {isMobileMenuOpen ? <XIcon size={20} data-id="element-106" /> : <MenuIcon size={20} data-id="element-107" />}
          </button>
        </div>
      </div>
      <AnimatePresence data-id="element-108">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white/95 backdrop-blur-xl border-t" data-id="element-109">
            <div className="px-4 py-4 space-y-3" data-id="element-110">
              <a href="#" className="block text-gray-700 hover:text-black font-medium text-sm" data-id="element-111">
                Home
              </a>
              <a href="#features" className="block text-gray-700 hover:text-black font-medium text-sm" data-id="element-112">
                Features
              </a>
              <a href="#how-it-works" className="block text-gray-700 hover:text-black font-medium text-sm" data-id="element-113">
                How It Works
              </a>
              <a href="#pricing" className="block text-gray-700 hover:text-black font-medium text-sm" data-id="element-114">
                Pricing
              </a>
              <a href="#testimonials" className="block text-gray-700 hover:text-black font-medium text-sm" data-id="element-115">
                Testimonials
              </a>
              <div className="pt-3 space-y-2" data-id="element-116">
                {isAuthenticated ? <>
                    <button onClick={() => {
                navigate('/dashboard');
                setIsMobileMenuOpen(false);
              }} className="w-full px-4 py-2 text-sm text-gray-700 font-medium border border-gray-200 rounded-full" data-id="element-117">
                      Dashboard
                    </button>
                    <button onClick={handleLogout} className="w-full px-4 py-2 text-sm bg-black text-white rounded-full font-medium" data-id="element-118">
                      Logout
                    </button>
                  </> : <>
                    <button onClick={() => {
                navigate('/login');
                setIsMobileMenuOpen(false);
              }} className="w-full px-4 py-2 text-sm text-gray-700 font-medium border border-gray-200 rounded-full" data-id="element-119">
                      Login
                    </button>
                    <button onClick={() => {
                navigate('/signup');
                setIsMobileMenuOpen(false);
              }} className="w-full px-4 py-2 text-sm bg-black text-white rounded-full font-medium" data-id="element-120">
                      Get Started
                    </button>
                  </>}
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.header>;
}